(function () {
  function render(root) {
    if (root.dataset.latestReady) return;
    var template = root.querySelector('[data-latest-review-source]');
    if (!template) return;
    var reviews = Array.from(template.content.querySelectorAll('.jdgm-rev')).map(function (review) {
      var time = review.querySelector('.jdgm-rev__timestamp');
      var date = time && new Date(time.getAttribute('datetime') || time.getAttribute('data-content'));
      return { node: review, date: date };
    }).filter(function (review) { return review.date && Number.isFinite(review.date.getTime()); })
      .sort(function (a, b) { return b.date - a.date; }).slice(0, 3);
    if (!reviews.length) return;
    var grid = root.querySelector('.nupdp-latest-grid');
    function text(parent, tag, className, value) {
      var el = document.createElement(tag); el.className = className; el.textContent = value; parent.appendChild(el); return el;
    }
    reviews.forEach(function (item) {
      var source = item.node;
      function value(selector) { var el = source.querySelector(selector); return el ? el.textContent.trim() : ''; }
      var card = document.createElement('article'); card.className = 'nu-latest-card';
      var meta = document.createElement('div'); meta.className = 'nu-latest-meta'; card.appendChild(meta);
      var rating = source.querySelector('.jdgm-rev__rating');
      var score = Number(rating && rating.dataset.score);
      if (Number.isInteger(score) && score >= 1 && score <= 5) {
        var stars = text(meta, 'span', 'nu-latest-stars', '★'.repeat(score) + '☆'.repeat(5-score));
        stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', score + ' na 5');
      }
      var time = text(meta, 'time', '', new Intl.DateTimeFormat('pl-PL', {day:'numeric', month:'long', year:'numeric', timeZone:'UTC'}).format(item.date));
      time.dateTime = item.date.toISOString();
      var title = value('.jdgm-rev__title'), body = value('.jdgm-rev__body');
      if (title) text(card, 'h3', '', title);
      if (body) text(card, 'p', '', body);
      text(card, 'div', 'nu-latest-author', value('.jdgm-rev__author'));
      if (source.dataset.verifiedBuyer === 'true') text(card, 'span', 'nu-latest-verified', '✓ ZWERYFIKOWANY ZAKUP');
      grid.appendChild(card);
    });
    root.dataset.latestReady = 'true'; root.hidden = false;
  }
  document.querySelectorAll('.nupdp-latest-reviews').forEach(render);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('.nupdp-latest-reviews').forEach(render); });
})();
